import React, { useState } from "react";
import useCollapse from 'react-collapsed';

import LottoHintCarousel from "components/lotto/default/LottoHintCarousel";
import DirectAdsComponent from "../../../components/lotto/default/DirectAdsComponent";
import CollapsibleHeader from "./CollapsibleHeader";

export function HintCollapsible({ topic, hintDataArray, hintInsightDataArray, slug, isShowAtRender }) {
  const [isExpanded, setExpanded] = useState(isShowAtRender);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  function handleOnClick() {
    setExpanded(!isExpanded);
  }

  return (
    <section className="collapsible" aria-label={topic}>
      <div
        className={isExpanded ? "header-expand" : "header-collapse"}
        {...getToggleProps({ onClick: handleOnClick })}
      >
        <CollapsibleHeader
          topic={topic}
          isExpanded={isExpanded}
          subtitle="คำชะโนด · ปฏิทินจีน"
        />
      </div>
      <div {...getCollapseProps()}>
        <div className="collapsible-panel">
          <p className="collapsible-intro">
            เช็คเลขเด็ดจากคำชะโนดและปฏิทินจีนประจำงวดนี้
          </p>
          <LottoHintCarousel
            hintDataArray={hintDataArray}
            hintInsightDataArray={hintInsightDataArray}
            slug={slug}
          />
          <DirectAdsComponent adsType="lazada_bonus_deeplink" />
        </div>
      </div>
    </section>
  );
}
